<template lang="pug">
  .flow-builder-action-find-product
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(
        v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)",
        :key="platform.platform_id",
        :style="{'background-color': platformColor(platform.name, 0.7)}"
      ) {{ platform.title }}
      b-badge(
        v-if="selectedPlatformsObjects.slice(sliceEnd).length",
        variant="soft-secondary"
      ) {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(
          placeholder="- Agregar plataformas -",
          :options="parsedPlatforms",
          :disabled="disabled",
          :value="selected_platforms",
          @input="updatePlatforms",
          multiple,
          :limit="3",
          :searchable="false",
        )
    b-card.mb-0.no-shadow.w-100.bg-light-white
      .bg-white
        p.mb-0 LLM
        p.text-secondary.text-sm Permite hacer una petición personalizada al LLM.
        fieldset(:disabled="disabled")
          b-form-group(
            label="Prompt:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'prompt'"
          )
            b-form-textarea.disabled-white(
              placeholder="Prompt",
              :value="template_attribute.value",
              @blur="updateTemplateAttribute(template_attribute, $event)"
            )
          b-form-group(
            label="Texto:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'text'"
          )
            b-form-textarea.disabled-white(
              placeholder="Text",
              :value="template_attribute.value",
              @blur="updateTemplateAttribute(template_attribute, $event)"
            )
          b-form-group(
            label="Context:",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'context'"
          )
            b-form-textarea.disabled-white(
              placeholder="Context",
              :value="template_attribute.value",
              @blur="updateTemplateAttribute(template_attribute, $event)"
            )
          .d-flex
            b-form-group(
              v-for="(template_attribute, template_attribute_index) in Template_Attributes",
              :key="template_attribute_index",
              v-if="template_attribute.name === 'chat_history'"
            )
              .d-flex
                p.mr-1 {{ 'Historial de chat: ' }}
                p {{ isChatHistoryActived === '1' ? 'Sí' : 'No' }}
                b-form-checkbox.ml-1(
                  v-model="template_attribute.value === '1'",
                  @change="updateTemplateAttribute(template_attribute, $event)"
                )
          b-form-group(
            :label="'Temperature: ' + template_attribute.value",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'temperature'"
          )
            b-form-input(
              type="range",
              v-model="template_attribute.value",
              @click="updateTemplateAttribute(template_attribute, $event)"
              controls,
              inline,
              center,
              placeholder="0.2",
              :min="0",
              :max="1",
              :step="0.01"
            )
          b-form-group(
            :label="'Top p: ' + template_attribute.value",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'top_p'"
          )
            b-form-input(
              type="range",
              v-model="template_attribute.value",
              @click="updateTemplateAttribute(template_attribute, $event)"
              controls,
              inline,
              center,
              placeholder="0.9",
              :min="0",
              :max="1",
              :step="0.01"
            )
          b-form-group(
            :label="'Top k: ' + template_attribute.value",
            v-for="(template_attribute, template_attribute_index) in Template_Attributes",
            :key="template_attribute_index",
            v-if="template_attribute.name === 'top_k'"
          )
            b-form-input(
              type="range",
              v-model="template_attribute.value",
              @click="updateTemplateAttribute(template_attribute, $event)"
              controls,
              inline,
              center,
              placeholder="20",
              :min="0",
              :step="1"
            )
      template-connector(
        v-for="connector in Template_Connectors",
        :key="connector.template_connector_id",
        v-bind="connector",
        :block_id="block_id",
        :disabled="disabled"
      )
</template>

<script>
import templateCommon from '@/helpers/template-common'
import TemplateTools from '@/components/templates/common/Tools.vue'
import _debounce from 'lodash.debounce'
import Connector from '@/components/templates/connectors/Connector.vue'

export default {
  mixins: [templateCommon],
  data () {
    return {
      isChatHistoryActived: false
    }
  },
  components: {
    'template-tools': TemplateTools,
    'template-connector': Connector
  },
  computed: {
  },
  methods: {
    findCheckHistory () {
      const templateAttributeFound = this.Template_Attributes.find((templateAttribute) => {
        return templateAttribute.name === 'chat_history'
      })

      this.isChatHistoryActived = templateAttributeFound.value
    }
  },
  created() {
    this.updateTemplateAttribute = _debounce((templateAttribute, value) => {
      const attribute = JSON.parse(JSON.stringify(templateAttribute))

      if (value && value.target) {
        attribute.value = value.target._value
      } else {
        this.isChatHistoryActived = value ? '1' : '0'
        attribute.value = value
      }

      this.updateAttribute(this.block_id, this.template_id, attribute).then(() => {
        this.$message.success('Actualizado')
      })
    }, 100, { leading: false, trailing: true })
  },
  mounted () {
    this.findCheckHistory()
  }
}
</script>

<style lang="scss" scoped>
  .flow-builder-action-find-product {
    position: relative;
    flex: 1 0 auto;
    max-width: 100%;
    background-color: transparent;
    white-space: normal;
  }
</style>
